import React, { useState, useEffect } from 'react';

export const Perk = ({ data, itemSelectHandler, optionSelectHandler }) => {
  const [isSelected, setSelected] = useState(false);
  const [buttonLabel, setButtonLabel] = useState('SELECT');

  const name = data.Name;
  const fromText = (!data.SetPrice) ? 'From ' : '';
  const shields = data.Shields;
  const isAvailable = !!data.Available;
  const isNew = !!data.New;
  const hasImage = data.Image !== '';
  const hasOptions = data.Options !== '';
  const parsedOptions = hasOptions ? JSON.parse(`[${data.Options}]`) : [];

  useEffect(() => {
    setButtonLabel(isSelected ? 'DESELECT' : 'SELECT');
  }, [isSelected]);

  const deselectHandler = () => setSelected(false);

  const selectHandler = () => {
    const newSelected = !isSelected;
    setSelected(newSelected);
    itemSelectHandler(name, shields, isSelected, deselectHandler);
  };

  return (
    <div className={`perks__menu-item ${isSelected ? 'selected' : ''}`}>
      <div className="perks__menu-item-inner">
        {hasImage && (
          <img
            className="perks__menu-item-image"
            src={data.Image}
            alt=""
          />
        )}
        <div className={'perks__menu-item-content'}>
          {isNew && <div className="new-tag">NEW</div>}
          <h4 dangerouslySetInnerHTML={{ __html: name }} />
          <p dangerouslySetInnerHTML={{ __html: data.Description }} />
          
          {hasOptions && (
            <ul className="perks__options-list">
              {parsedOptions.map((option, key) => (
                <li key={key}>
                  <label>
                    <input
                      type="radio"
                      name={name}
                      value={option.name}
                      onClick={() => optionSelectHandler(name, option.name)}
                      disabled={!isSelected}
                    />
                    {option.name}
                  </label>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="perks__menu-item-footer">
          {shields > 0 && <h5>{fromText}{shields} Shields</h5>}

          {isAvailable ? (
            <button
              className="button large perks__select-btn"
              onClick={selectHandler}
            >
              {buttonLabel}
            </button>
          ) : (
            <p><strong>Sorry, this is no longer available.</strong></p>
          )}
        </div>
      </div>
    </div>
  );
};
